import { useHistory } from "react-router-dom";

import { NavigationItem } from "../components/navigation_pill";
import { MarketplacePage } from "../constants/marketplace_page";
import { useMarketplaceContext } from "../contexts/marketplace_context";

export const useNavigationItems = (): NavigationItem<MarketplacePage>[] => {
  const history = useHistory();
  const { setSelectedRole } = useMarketplaceContext();

  return [
    {
      id: MarketplacePage.Dashboard,
      type: "icon",
      iconName: "home",
      onClick: () => {
        history.push("/marketplace/dashboard");
        setSelectedRole(null);
      }
    },
    {
      id: MarketplacePage.WorkOpportunities,
      type: "icon",
      iconName: "work",
      onClick: () => history.push("/marketplace/work_opportunities/matching_roles")
    }
  ];
};
